import "./marginChangeData.css";
import React from 'react';

const CreditMarginChangeData = (props) => {

    const MarginChangeData = props.creditMarginChanges.map(creditMarginChange => (
        <>
            <tr key={creditMarginChange.key}>
                    <td>
                        {creditMarginChange.date}
                    </td>
                    <td>
                        {creditMarginChange.value}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={creditMarginChange.key} onClick={props.handleDeleteCreditMarginChange}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    const lenghtChangeDataStructure = (
        <table className="marginChangeTable">
                <tbody>
                    <tr>
                        <th>Data</th>
                        <th>Wartość</th>
                        <th>Akcja</th>
                    </tr>
                    {MarginChangeData}
                </tbody>
        </table> 
    )

    return ( 
        <>
            <div className="tableRow">
                {props.creditMarginChanges.length === 0 ? '' : lenghtChangeDataStructure}
            </div>  
        </>
    );
}
 
export default CreditMarginChangeData;
